import { render, staticRenderFns } from "./UserActivitiesTable.vue?vue&type=template&id=22e97fa2"
import script from "./UserActivitiesTable.vue?vue&type=script&lang=js"
export * from "./UserActivitiesTable.vue?vue&type=script&lang=js"
import style0 from "./UserActivitiesTable.vue?vue&type=style&index=0&id=22e97fa2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports